module.exports = __webpack_public_path__ + "static/media/My.0ba99c2c.jpg";